/**
 * Filtros do relatório, com o seletor de VISÃO SALVA.
 *
 * Tudo o que se escolhe aqui vai para a QUERY STRING da URL, e é de lá que a
 * tela lê ao abrir. Consequência prática: o link é compartilhável — o dono
 * manda `/reports/orders?visao=mix&de=2025-07-01` para o gerente e o gerente
 * abre exatamente a mesma tela. Escolher a visão também troca o `agruparPor`,
 * porque uma visão É filtro + agrupamento (§7.5).
 *
 * A visão desabilitada (comissão por atendente) aparece na lista, desabilitada,
 * com o motivo no `title`: some do menu sem explicação pareceria esquecimento.
 */
import React from "react";
import * as AlfredoStyles from "../../styles/components/reports/RelatorioComum";
import { VISOES_DE_VENDA, type VisaoDeVenda } from "../../comum/relatorios/visoes";

interface Props {
  de: string;
  ate: string;
  turno: string;
  canal: string;
  visao: string;
  turnos?: string[];
  /** Some o seletor de visão nas telas que não são de venda (Caixa). */
  mostrarVisoes?: boolean;
  visaoEscolhida?: VisaoDeVenda;
  aoMudar: (campo: string, valor: string) => void;
  aoLimpar: () => void;
}

const CANAIS = [
  { valor: "", rotulo: "Todos" },
  { valor: "1", rotulo: "Salão" },
  { valor: "2", rotulo: "Balcão" },
  { valor: "3", rotulo: "Delivery" },
];

const FiltrosDoRelatorio: React.FC<Props> = ({
  de,
  ate,
  turno,
  canal,
  visao,
  turnos,
  mostrarVisoes = true,
  visaoEscolhida,
  aoMudar,
  aoLimpar,
}) => {
  return (
    <AlfredoStyles.Filtros onSubmit={(evento) => evento.preventDefault()}>
      <AlfredoStyles.Campo>
        De
        <AlfredoStyles.Entrada
          type="date"
          value={de}
          onChange={(evento) => aoMudar("de", evento.target.value)}
        />
      </AlfredoStyles.Campo>

      <AlfredoStyles.Campo>
        Até
        <AlfredoStyles.Entrada
          type="date"
          value={ate}
          onChange={(evento) => aoMudar("ate", evento.target.value)}
        />
      </AlfredoStyles.Campo>

      <AlfredoStyles.Campo>
        Turno
        <AlfredoStyles.Selecao
          value={turno}
          onChange={(evento) => aoMudar("turno", evento.target.value)}
        >
          <option value="">Todos</option>
          {(turnos ?? []).map((nome) => (
            <option key={nome} value={nome}>
              {nome}
            </option>
          ))}
        </AlfredoStyles.Selecao>
      </AlfredoStyles.Campo>

      {mostrarVisoes && (
        <>
          <AlfredoStyles.Campo>
            Canal
            <AlfredoStyles.Selecao
              value={canal}
              onChange={(evento) => aoMudar("canal", evento.target.value)}
            >
              {CANAIS.map((opcao) => (
                <option key={opcao.valor} value={opcao.valor}>
                  {opcao.rotulo}
                </option>
              ))}
            </AlfredoStyles.Selecao>
          </AlfredoStyles.Campo>

          <AlfredoStyles.Campo>
            Visão salva
            <AlfredoStyles.Selecao
              value={visao}
              onChange={(evento) => aoMudar("visao", evento.target.value)}
            >
              <option value="">Linha de pedido (sem agrupamento)</option>
              {VISOES_DE_VENDA.map((opcao) => (
                <option
                  key={opcao.id}
                  value={opcao.id}
                  disabled={Boolean(opcao.desabilitada)}
                  title={opcao.desabilitada ?? opcao.pergunta}
                >
                  {opcao.titulo}
                  {opcao.desabilitada ? " (indisponível)" : ""}
                </option>
              ))}
            </AlfredoStyles.Selecao>
          </AlfredoStyles.Campo>
        </>
      )}

      <AlfredoStyles.BotaoSecundario type="button" onClick={aoLimpar}>
        Limpar
      </AlfredoStyles.BotaoSecundario>

      {visaoEscolhida && (
        <AlfredoStyles.PerguntaDaVisao>
          {visaoEscolhida.pergunta}
          {visaoEscolhida.agruparPor.length > 0 &&
            ` — agrupado por ${visaoEscolhida.agruparPor.join(", ")}.`}
        </AlfredoStyles.PerguntaDaVisao>
      )}
    </AlfredoStyles.Filtros>
  );
};

export default FiltrosDoRelatorio;
